import React, { useState } from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';
import usePost from '../../../../Hooks/usePost';
import UpdatePaymentModal from '../../Advertisers/UpdatePaymentModal';
import AddPaymentMethodModal from '../../Advertisers/AddPaymentMethodModal';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import useRequest from '../../../../Hooks/useRequest';
import { StyledButton } from '../../../../Components/Generics.styled';
import { useProfile } from '../../../../Contexts/UserProfileContext';
import { useHistory } from 'react-router-dom';
import Checkout from '../../../../Components/Payments/Checkout';
import dayjs from 'dayjs';

const PayForCampaignContainer = styled.div`
    margin-top: 100px;
    margin-bottom: 30px;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const PayForCampaignApplet = styled.div`
    margin-bottom: 10px;
    display: flex;
    height: 130px;
    width: 100%;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
    margin-bottom: 10px;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 300px;
`;

const TotalContainer = styled.div`
    font-size: 23px;
    margin-bottom: 16px;
    font-weight: bold;
`;

const TotalValue = styled.span`
    font-weight: 200;
`;

const StyledPaymentMethodApplet = styled.div`
    height: 100%;
    width: 100%;
    max-width: 200px;
    border: 1px dashed black;
    border-radius: 12px;
    padding: 12px;
    background-color: #fafbf7;

    cursor: pointer;
    :hover {
        background-color: #2e69fe;
        color: #fafbf7;
    }

    @media only screen and (max-width: 620px) {
        margin-bottom: 10px;
    }
`;

const AddPaymentButton = styled.div`
    margin-top: 20px;
    padding: 12px;
    font-size: 24px;
    text-align: center;
`;

const Brand = styled.div`
    font-size: 23px;
`;
const Country = styled.div``;
const ExpYear = styled.div``;
const IsDefault = styled.div``;
const ExpMonth = styled.div``;
const Last4 = styled.div``;

const PaymentMethodSection = styled.div`
    width: 100%;
    max-width: 700px;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    height: 200px;
    display: flex;
`;

const PaymentMethodChild = styled.div`
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-evenly;
`;

const PayForCampaign = (props) => {
    const { campaignData, handleNavButtonBack, handleNavButtonNext, saveNewCampaign, campaignPostData, setCampaignPostData, currentAdvertiser } =
        props;

    const { budget, campaignName, campaignTypeName, startDate, endDate } = { ...campaignData };

    return (
        <PayForCampaignContainer>
            <Title>Pay for your campaign</Title>
            <Checkout
                currentAdvertiser={currentAdvertiser}
                price={budget}
                onCheckout={saveNewCampaign}
                itemName={`${campaignName} Ad Campaign`}
                // taxPercent={6}
                afterCheckout={handleNavButtonNext}
                itemDescription={`${campaignTypeName.charAt(0).toUpperCase() + campaignTypeName.slice(1)} Ad Campaign running from ${dayjs(
                    startDate
                ).format('MM/DD/YYYY')} to ${dayjs(endDate).format('MM/DD/YYYY')}`}
            />

            <StyledNavButtons>
                <StyledButton variant="contained" color="primary" onClick={() => handleNavButtonBack()}>
                    Back
                </StyledButton>
            </StyledNavButtons>
        </PayForCampaignContainer>
    );
};

PayForCampaign.propTypes = {
    campaignData: propTypes.shape({
        creditCardNumber: propTypes.string,
        creditCardExpirationDate: propTypes.string,
        cvc: propTypes.string,
        creditCardName: propTypes.string,
        creditCardEmail: propTypes.string,
        creditCardPhone: propTypes.string,
        paymentInfoStreet: propTypes.string,
        paymentInfoCity: propTypes.string,
        paymentInfoState: propTypes.string,
        paymentInfoZipCode: propTypes.string,
        stripePaymentId: propTypes.string,
        stripeCustomerId: propTypes.string,
        amount: propTypes.string,
    }),
    currentAdvertiser: propTypes.shape({
        chargeCreditCard: propTypes.bool,
    }),
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    advertisers: propTypes.shape({}),
    saveNewCampaign: propTypes.func,
    campaignPostData: propTypes.shape({
        isLoading: propTypes.bool,
        success: propTypes.bool,
        error: propTypes.bool,
        message: propTypes.array,
    }),
    setCampaignPostData: propTypes.func,
};

PayForCampaign.defaultProps = {
    campaignData: {},
    setCampaignData: () => {},
    saveNewCampaign: () => {},
    setCampaignPostData: () => {},
};
export default PayForCampaign;
